<template>
  <admin-wrapper :inputs="inputs" :is-form-fetched="isFormFetched" @save="onSave">
    <template #scadaDataSource.input="data">
      <v-col cols="3">
        <data-input v-model="selectedDataSource.datasource" v-bind="data" @change="selectedDataSourceChanged = true" />
      </v-col>
    </template>
  </admin-wrapper>
</template>

<script>
import { call } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';

export default {
  name: 'ScadaThreeTabData',
  components: {
    AdminWrapper,
    DataInput,
  },
  props: {
    isModuleEnabled: {
      type: Boolean,
      default: false,
    },
    dataSources: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedDataSource: {
      datasource: '',
    },
    selectedDataSourceChanged: false,
    isFormFetched: false,
  }),
  computed: {
    dataSourceSettingsName() {
      return 'scada_3_points';
    },
    dataSourcesFiltered() {
      return this.dataSources.filter(dataSource => dataSource.scope === 'core' && !dataSource.module);
    },
    inputs() {
      return [
        {
          name: 'scadaDataSource',
          translationPath: 'admin.scadaDataSource',
          dataType: {
            name: 'select',
          },
          rules: [v => !!v || v == '0' || 'rules.required'],
          align: 'start',
          items: this.dataSourcesFiltered,
          itemValue: 'name',
          itemText: 'verbose_name',
        },
        {
          name: 'scada_3_module_measurements_refresh_interval',
          translationPath: 'admin.refreshInterval',
          subtitle: 'admin.setScadaRefreshInterval',
          dataType: {
            name: 'integer',
          },
          rules: [v => v === 0 || Boolean(v) || 'rules.required'],
          align: 'start',
          disabled: !this.selectedDataSource.datasource,
          allowNegative: false,
          minValue: 1,
        },
      ];
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
  methods: {
    getDatasourceSettings: call('datasourceSettings/getDatasourceSettings'),
    editDatasourceSettings: call('datasourceSettings/editDatasourceSettings'),
    async init() {
      if (this.isModuleEnabled) {
        await this.updateSelectedDataSource();
      }
      this.isFormFetched = true;
    },
    async updateSelectedDataSource() {
      try {
        const { datasource } = await this.getDatasourceSettings(this.dataSourceSettingsName);
        this.selectedDataSource = {
          datasource,
        };
      } catch {
        this.selectedDataSource = {
          datasource: '',
        };
      } finally {
        this.selectedDataSourceChanged = false;
      }
    },
    async onSave() {
      if (!this.selectedDataSourceChanged) {
        return;
      }
      const payload = { name: this.dataSourceSettingsName, settings: this.selectedDataSource };
      try {
        await this.editDatasourceSettings(payload);
        this.selectedDataSourceChanged = false;
      } catch {
        //
      }
    },
  },
};
</script>
